// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file tournament_bay_session.proto (package evenplay.bay_session.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file tournament_bay_session.proto.
 */
export const file_tournament_bay_session: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * Error is the information passed back from a microservice to indicate the
 * state of a request. Mirror of qb.smg.Error.
 *
 * @generated from message evenplay.bay_session.v1.Error
 */
export type Error = Message<"evenplay.bay_session.v1.Error"> & {
  /**
   * The numeric code for this error.
   *
   * @generated from field: int64 code = 1;
   */
  code: bigint;

  /**
   * The informative message for this error.
   *
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message evenplay.bay_session.v1.Error.
 * Use `create(ErrorSchema)` to create a new message.
 */
export const ErrorSchema: GenMessage<Error> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 0);

/**
 * Location mirrors qb.smg.Location (jurisdiction geofence on join/verify).
 *
 * @generated from message evenplay.bay_session.v1.Location
 */
export type Location = Message<"evenplay.bay_session.v1.Location"> & {
  /**
   * @generated from field: double latitude = 1;
   */
  latitude: number;

  /**
   * @generated from field: double longitude = 2;
   */
  longitude: number;
};

/**
 * Describes the message evenplay.bay_session.v1.Location.
 * Use `create(LocationSchema)` to create a new message.
 */
export const LocationSchema: GenMessage<Location> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 1);

/**
 * @generated from message evenplay.bay_session.v1.TournamentPlayerBet
 */
export type TournamentPlayerBet = Message<"evenplay.bay_session.v1.TournamentPlayerBet"> & {
  /**
   * @generated from field: int32 bet_id = 1;
   */
  betId: number;

  /**
   * @generated from field: evenplay.bay_session.v1.TournamentPlayerBet.State state = 2;
   */
  state: TournamentPlayerBet_State;

  /**
   * @generated from field: bool resolved = 3;
   */
  resolved: boolean;

  /**
   * Wallet stake on this overlay shot (smg_bet.amount). Mint writes 0;
   * AcceptBet copies the pin and charges this amount. Unplayed rows stay 0.
   *
   * @generated from field: int64 amount = 4;
   */
  amount: bigint;

  /**
   * @generated from field: int64 multiplier = 5;
   */
  multiplier: bigint;

  /**
   * @generated from field: string outcome = 6;
   */
  outcome: string;

  /**
   * @generated from field: int64 created_on = 7;
   */
  createdOn: bigint;

  /**
   * @generated from field: int64 station_id = 8;
   */
  stationId: bigint;
};

/**
 * Describes the message evenplay.bay_session.v1.TournamentPlayerBet.
 * Use `create(TournamentPlayerBetSchema)` to create a new message.
 */
export const TournamentPlayerBetSchema: GenMessage<TournamentPlayerBet> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 2);

/**
 * @generated from enum evenplay.bay_session.v1.TournamentPlayerBet.State
 */
export enum TournamentPlayerBet_State {
  /**
   * @generated from enum value: PENDING = 0;
   */
  PENDING = 0,

  /**
   * @generated from enum value: PLAYING = 1;
   */
  PLAYING = 1,

  /**
   * @generated from enum value: FINISHED = 2;
   */
  FINISHED = 2,

  /**
   * @generated from enum value: CANCELLED = 3;
   */
  CANCELLED = 3,
}

/**
 * Describes the enum evenplay.bay_session.v1.TournamentPlayerBet.State.
 */
export const TournamentPlayerBet_StateSchema: GenEnum<TournamentPlayerBet_State> = /*@__PURE__*/
  enumDesc(file_tournament_bay_session, 2, 0);

/**
 * @generated from message evenplay.bay_session.v1.TournamentOwner
 */
export type TournamentOwner = Message<"evenplay.bay_session.v1.TournamentOwner"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string username = 2;
   */
  username: string;

  /**
   * @generated from field: string firstName = 3;
   */
  firstName: string;

  /**
   * @generated from field: string lastName = 4;
   */
  lastName: string;
};

/**
 * Describes the message evenplay.bay_session.v1.TournamentOwner.
 * Use `create(TournamentOwnerSchema)` to create a new message.
 */
export const TournamentOwnerSchema: GenMessage<TournamentOwner> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 3);

/**
 * @generated from message evenplay.bay_session.v1.TournamentPrizeDistributionItem
 */
export type TournamentPrizeDistributionItem = Message<"evenplay.bay_session.v1.TournamentPrizeDistributionItem"> & {
  /**
   * @generated from field: int32 place = 1;
   */
  place: number;

  /**
   * @generated from field: evenplay.bay_session.v1.TournamentPrizeDistributionItem.AwardKind kind = 2;
   */
  kind: TournamentPrizeDistributionItem_AwardKind;

  /**
   * @generated from field: int32 static_award_prize = 3;
   */
  staticAwardPrize: number;

  /**
   * @generated from field: int32 percentage_of_pool = 4;
   */
  percentageOfPool: number;

  /**
   * @generated from field: int32 calculated_award_prize = 5;
   */
  calculatedAwardPrize: number;

  /**
   * @generated from field: int32 additional_cash_prize = 6;
   */
  additionalCashPrize: number;
};

/**
 * Describes the message evenplay.bay_session.v1.TournamentPrizeDistributionItem.
 * Use `create(TournamentPrizeDistributionItemSchema)` to create a new message.
 */
export const TournamentPrizeDistributionItemSchema: GenMessage<TournamentPrizeDistributionItem> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 4);

/**
 * @generated from enum evenplay.bay_session.v1.TournamentPrizeDistributionItem.AwardKind
 */
export enum TournamentPrizeDistributionItem_AwardKind {
  /**
   * @generated from enum value: STATIC = 0;
   */
  STATIC = 0,

  /**
   * @generated from enum value: TICKET = 1;
   */
  TICKET = 1,

  /**
   * @generated from enum value: PERCENTAGE_OF_POOL = 2;
   */
  PERCENTAGE_OF_POOL = 2,

  /**
   * @generated from enum value: PHYSICAL_PRIZE = 3;
   */
  PHYSICAL_PRIZE = 3,
}

/**
 * Describes the enum evenplay.bay_session.v1.TournamentPrizeDistributionItem.AwardKind.
 */
export const TournamentPrizeDistributionItem_AwardKindSchema: GenEnum<TournamentPrizeDistributionItem_AwardKind> = /*@__PURE__*/
  enumDesc(file_tournament_bay_session, 4, 0);

/**
 * @generated from message evenplay.bay_session.v1.TournamentPrizeDistribution
 */
export type TournamentPrizeDistribution = Message<"evenplay.bay_session.v1.TournamentPrizeDistribution"> & {
  /**
   * @generated from field: repeated evenplay.bay_session.v1.TournamentPrizeDistributionItem items = 1;
   */
  items: TournamentPrizeDistributionItem[];
};

/**
 * Describes the message evenplay.bay_session.v1.TournamentPrizeDistribution.
 * Use `create(TournamentPrizeDistributionSchema)` to create a new message.
 */
export const TournamentPrizeDistributionSchema: GenMessage<TournamentPrizeDistribution> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 5);

/**
 * @generated from message evenplay.bay_session.v1.TournamentPlayerDetails
 */
export type TournamentPlayerDetails = Message<"evenplay.bay_session.v1.TournamentPlayerDetails"> & {
  /**
   * @generated from field: int32 player_id = 1;
   */
  playerId: number;

  /**
   * @generated from field: string player_name = 2;
   */
  playerName: string;

  /**
   * @generated from field: string player_first_name = 10;
   */
  playerFirstName: string;

  /**
   * @generated from field: string player_last_name = 11;
   */
  playerLastName: string;

  /**
   * @generated from field: repeated evenplay.bay_session.v1.TournamentPlayerBet bets = 3;
   */
  bets: TournamentPlayerBet[];

  /**
   * @generated from field: evenplay.bay_session.v1.TournamentPlayerDetails.State state = 4;
   */
  state: TournamentPlayerDetails_State;

  /**
   * @generated from field: bool won = 5;
   */
  won: boolean;

  /**
   * @generated from field: int32 score = 6;
   */
  score: number;

  /**
   * @generated from field: int32 prize = 7;
   */
  prize: number;

  /**
   * @generated from field: int32 betEntreeFee = 8;
   */
  betEntreeFee: number;

  /**
   * @generated from field: int32 rank = 9;
   */
  rank: number;

  /**
   * @generated from field: string email = 12;
   */
  email: string;

  /**
   * @generated from field: int32 station_id = 13;
   */
  stationId: number;

  /**
   * @generated from field: int32 total_contest_fees = 14;
   */
  totalContestFees: number;

  /**
   * @generated from field: evenplay.bay_session.v1.TournamentPrizeDistributionItem prize_distributionItem = 15;
   */
  prizeDistributionItem?: TournamentPrizeDistributionItem;

  /**
   * Resolved overlay shots (taken), excluding CANCELLED. Mirror of qb.smg.
   *
   * @generated from field: int32 bets_placed = 16;
   */
  betsPlaced: number;

  /**
   * @generated from field: int32 bets_allocated = 17;
   */
  betsAllocated: number;

  /**
   * @generated from field: int64 wagered = 18;
   */
  wagered: bigint;
};

/**
 * Describes the message evenplay.bay_session.v1.TournamentPlayerDetails.
 * Use `create(TournamentPlayerDetailsSchema)` to create a new message.
 */
export const TournamentPlayerDetailsSchema: GenMessage<TournamentPlayerDetails> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 6);

/**
 * @generated from enum evenplay.bay_session.v1.TournamentPlayerDetails.State
 */
export enum TournamentPlayerDetails_State {
  /**
   * @generated from enum value: PENDING = 0;
   */
  PENDING = 0,

  /**
   * @generated from enum value: PLAYING = 1;
   */
  PLAYING = 1,

  /**
   * @generated from enum value: FINISHED = 2;
   */
  FINISHED = 2,
}

/**
 * Describes the enum evenplay.bay_session.v1.TournamentPlayerDetails.State.
 */
export const TournamentPlayerDetails_StateSchema: GenEnum<TournamentPlayerDetails_State> = /*@__PURE__*/
  enumDesc(file_tournament_bay_session, 6, 0);

/**
 * @generated from message evenplay.bay_session.v1.TournamentSurveyQuestion
 */
export type TournamentSurveyQuestion = Message<"evenplay.bay_session.v1.TournamentSurveyQuestion"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string text = 2;
   */
  text: string;

  /**
   * @generated from field: evenplay.bay_session.v1.TournamentSurveyQuestionType type = 3;
   */
  type: TournamentSurveyQuestionType;

  /**
   * @generated from field: repeated string options = 4;
   */
  options: string[];
};

/**
 * Describes the message evenplay.bay_session.v1.TournamentSurveyQuestion.
 * Use `create(TournamentSurveyQuestionSchema)` to create a new message.
 */
export const TournamentSurveyQuestionSchema: GenMessage<TournamentSurveyQuestion> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 7);

/**
 * @generated from message evenplay.bay_session.v1.TournamentSurveyAnswer
 */
export type TournamentSurveyAnswer = Message<"evenplay.bay_session.v1.TournamentSurveyAnswer"> & {
  /**
   * @generated from field: int32 questionId = 1;
   */
  questionId: number;

  /**
   * @generated from field: repeated string response = 2;
   */
  response: string[];
};

/**
 * Describes the message evenplay.bay_session.v1.TournamentSurveyAnswer.
 * Use `create(TournamentSurveyAnswerSchema)` to create a new message.
 */
export const TournamentSurveyAnswerSchema: GenMessage<TournamentSurveyAnswer> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 8);

/**
 * Comprehensive information about a tournament. Mirror of qb.smg.Tournament.
 *
 * @generated from message evenplay.bay_session.v1.Tournament
 */
export type Tournament = Message<"evenplay.bay_session.v1.Tournament"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: bool isPrivate = 3;
   */
  isPrivate: boolean;

  /**
   * @generated from field: string criteriaStates = 4;
   */
  criteriaStates: string;

  /**
   * @generated from field: string criteriaCities = 5;
   */
  criteriaCities: string;

  /**
   * @generated from field: string criteriaVenues = 6;
   */
  criteriaVenues: string;

  /**
   * @generated from field: int64 entryBeginDate = 7;
   */
  entryBeginDate: bigint;

  /**
   * @generated from field: int64 entryEndDate = 8;
   */
  entryEndDate: bigint;

  /**
   * @generated from field: int64 startDate = 23;
   */
  startDate: bigint;

  /**
   * @generated from field: int64 finishDate = 21;
   */
  finishDate: bigint;

  /**
   * @generated from field: int32 minimumGuaranteedPricePool = 9;
   */
  minimumGuaranteedPricePool: number;

  /**
   * @generated from field: int32 entryFee = 10;
   */
  entryFee: number;

  /**
   * @generated from field: int32 rake = 11;
   */
  rake: number;

  /**
   * @generated from field: repeated int32 prizePool = 12;
   */
  prizePool: number[];

  /**
   * @generated from field: evenplay.bay_session.v1.TournamentPlayerDetails currentPlayerDetails = 13;
   */
  currentPlayerDetails?: TournamentPlayerDetails;

  /**
   * @generated from field: repeated evenplay.bay_session.v1.TournamentPlayerDetails playerDetails = 14;
   */
  playerDetails: TournamentPlayerDetails[];

  /**
   * @generated from field: evenplay.bay_session.v1.TournamentState state = 15;
   */
  state: TournamentState;

  /**
   * @generated from field: int32 maxParticipants = 16;
   */
  maxParticipants: number;

  /**
   * @generated from field: int32 totalShots = 17;
   */
  totalShots: number;

  /**
   * @generated from field: evenplay.bay_session.v1.TournamentOwner owner = 18;
   */
  owner?: TournamentOwner;

  /**
   * @generated from field: int64 expirationDate = 19;
   */
  expirationDate: bigint;

  /**
   * @generated from field: string sponsorLogo = 20;
   */
  sponsorLogo: string;

  /**
   * @generated from field: string tournament_code = 22;
   */
  tournamentCode: string;

  /**
   * @generated from field: repeated evenplay.bay_session.v1.TournamentSurveyQuestion questions = 24;
   */
  questions: TournamentSurveyQuestion[];

  /**
   * @generated from field: bool physical_prizing = 25;
   */
  physicalPrizing: boolean;

  /**
   * @generated from field: int32 venue_id = 26;
   */
  venueId: number;

  /**
   * @generated from field: string sponsor_landscape_logo = 27;
   */
  sponsorLandscapeLogo: string;

  /**
   * @generated from field: bool is_featured = 28;
   */
  isFeatured: boolean;

  /**
   * @generated from field: evenplay.bay_session.v1.TournamentJoinOptions join_options = 29;
   */
  joinOptions: TournamentJoinOptions;

  /**
   * @generated from field: int32 series_id = 30;
   */
  seriesId: number;

  /**
   * @generated from field: int32 min_participants = 31;
   */
  minParticipants: number;

  /**
   * @generated from field: int32 participant_count = 32;
   */
  participantCount: number;
};

/**
 * Describes the message evenplay.bay_session.v1.Tournament.
 * Use `create(TournamentSchema)` to create a new message.
 */
export const TournamentSchema: GenMessage<Tournament> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 9);

/**
 * @generated from message evenplay.bay_session.v1.LevelTournamentBasicDetails
 */
export type LevelTournamentBasicDetails = Message<"evenplay.bay_session.v1.LevelTournamentBasicDetails"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: int32 entry_fee = 10;
   */
  entryFee: number;

  /**
   * @generated from field: int64 entry_begin_date = 7;
   */
  entryBeginDate: bigint;

  /**
   * @generated from field: int64 entry_end_date = 8;
   */
  entryEndDate: bigint;

  /**
   * @generated from field: evenplay.bay_session.v1.LevelTournamentBasicDetails.State current_player_state = 12;
   */
  currentPlayerState: LevelTournamentBasicDetails_State;

  /**
   * @generated from field: bool current_player_joined = 13;
   */
  currentPlayerJoined: boolean;

  /**
   * @generated from field: int32 number_of_participants = 14;
   */
  numberOfParticipants: number;

  /**
   * @generated from field: int32 max_participants = 15;
   */
  maxParticipants: number;

  /**
   * @generated from field: evenplay.bay_session.v1.TournamentPrizeDistributionItem first_place_award = 9;
   */
  firstPlaceAward?: TournamentPrizeDistributionItem;
};

/**
 * Describes the message evenplay.bay_session.v1.LevelTournamentBasicDetails.
 * Use `create(LevelTournamentBasicDetailsSchema)` to create a new message.
 */
export const LevelTournamentBasicDetailsSchema: GenMessage<LevelTournamentBasicDetails> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 10);

/**
 * @generated from enum evenplay.bay_session.v1.LevelTournamentBasicDetails.State
 */
export enum LevelTournamentBasicDetails_State {
  /**
   * @generated from enum value: PENDING = 0;
   */
  PENDING = 0,

  /**
   * @generated from enum value: PLAYING = 1;
   */
  PLAYING = 1,

  /**
   * @generated from enum value: FINISHED = 2;
   */
  FINISHED = 2,
}

/**
 * Describes the enum evenplay.bay_session.v1.LevelTournamentBasicDetails.State.
 */
export const LevelTournamentBasicDetails_StateSchema: GenEnum<LevelTournamentBasicDetails_State> = /*@__PURE__*/
  enumDesc(file_tournament_bay_session, 10, 0);

/**
 * @generated from message evenplay.bay_session.v1.LevelTournamentList
 */
export type LevelTournamentList = Message<"evenplay.bay_session.v1.LevelTournamentList"> & {
  /**
   * @generated from field: int32 level = 1;
   */
  level: number;

  /**
   * @generated from field: repeated evenplay.bay_session.v1.LevelTournamentBasicDetails tournaments = 2;
   */
  tournaments: LevelTournamentBasicDetails[];
};

/**
 * Describes the message evenplay.bay_session.v1.LevelTournamentList.
 * Use `create(LevelTournamentListSchema)` to create a new message.
 */
export const LevelTournamentListSchema: GenMessage<LevelTournamentList> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 11);

/**
 * @generated from message evenplay.bay_session.v1.TournamentMetadata
 */
export type TournamentMetadata = Message<"evenplay.bay_session.v1.TournamentMetadata"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: evenplay.bay_session.v1.TournamentState state = 3;
   */
  state: TournamentState;

  /**
   * @generated from field: int32 shot_count = 4;
   */
  shotCount: number;

  /**
   * @generated from field: string sponsor_logo = 5;
   */
  sponsorLogo: string;

  /**
   * @generated from field: string sponsor_landscape_logo = 6;
   */
  sponsorLandscapeLogo: string;

  /**
   * @generated from field: int64 start_date = 7;
   */
  startDate: bigint;

  /**
   * @generated from field: int64 finish_date = 8;
   */
  finishDate: bigint;

  /**
   * @generated from field: int64 expiration_date = 9;
   */
  expirationDate: bigint;
};

/**
 * Describes the message evenplay.bay_session.v1.TournamentMetadata.
 * Use `create(TournamentMetadataSchema)` to create a new message.
 */
export const TournamentMetadataSchema: GenMessage<TournamentMetadata> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 12);

/**
 * @generated from message evenplay.bay_session.v1.TournamentLeaderBoardEntry
 */
export type TournamentLeaderBoardEntry = Message<"evenplay.bay_session.v1.TournamentLeaderBoardEntry"> & {
  /**
   * @generated from field: int32 rank = 1;
   */
  rank: number;

  /**
   * @generated from field: string playerUsername = 2;
   */
  playerUsername: string;

  /**
   * @generated from field: string playerFirstName = 3;
   */
  playerFirstName: string;

  /**
   * @generated from field: string playerLastName = 4;
   */
  playerLastName: string;

  /**
   * @generated from field: int32 score = 5;
   */
  score: number;

  /**
   * @generated from field: int32 shotsCompleted = 6;
   */
  shotsCompleted: number;

  /**
   * @generated from field: bool isCurrentUser = 7;
   */
  isCurrentUser: boolean;

  /**
   * @generated from field: string playerUsernameId = 8;
   */
  playerUsernameId: string;
};

/**
 * Describes the message evenplay.bay_session.v1.TournamentLeaderBoardEntry.
 * Use `create(TournamentLeaderBoardEntrySchema)` to create a new message.
 */
export const TournamentLeaderBoardEntrySchema: GenMessage<TournamentLeaderBoardEntry> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 13);

/**
 * @generated from message evenplay.bay_session.v1.GetTournamentPlayerEntry
 */
export type GetTournamentPlayerEntry = Message<"evenplay.bay_session.v1.GetTournamentPlayerEntry"> & {
  /**
   * @generated from field: string playerUsername = 2;
   */
  playerUsername: string;

  /**
   * @generated from field: string playerFirstName = 3;
   */
  playerFirstName: string;

  /**
   * @generated from field: string playerLastName = 4;
   */
  playerLastName: string;
};

/**
 * Describes the message evenplay.bay_session.v1.GetTournamentPlayerEntry.
 * Use `create(GetTournamentPlayerEntrySchema)` to create a new message.
 */
export const GetTournamentPlayerEntrySchema: GenMessage<GetTournamentPlayerEntry> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 14);

/**
 * @generated from message evenplay.bay_session.v1.ListTournamentRequest
 */
export type ListTournamentRequest = Message<"evenplay.bay_session.v1.ListTournamentRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: bool mineOnly = 4;
   */
  mineOnly: boolean;

  /**
   * @generated from field: bool showLastTwoDaysForPastTournaments = 6;
   */
  showLastTwoDaysForPastTournaments: boolean;

  /**
   * @generated from field: repeated evenplay.bay_session.v1.ListTournamentRequest.TournamentAccess tournamentAccess = 2;
   */
  tournamentAccess: ListTournamentRequest_TournamentAccess[];

  /**
   * @generated from field: repeated evenplay.bay_session.v1.TournamentState states = 3;
   */
  states: TournamentState[];

  /**
   * @generated from field: evenplay.bay_session.v1.ListTournamentRequest.Sort sort = 5;
   */
  sort: ListTournamentRequest_Sort;
};

/**
 * Describes the message evenplay.bay_session.v1.ListTournamentRequest.
 * Use `create(ListTournamentRequestSchema)` to create a new message.
 */
export const ListTournamentRequestSchema: GenMessage<ListTournamentRequest> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 15);

/**
 * @generated from enum evenplay.bay_session.v1.ListTournamentRequest.TournamentAccess
 */
export enum ListTournamentRequest_TournamentAccess {
  /**
   * @generated from enum value: PUBLIC = 0;
   */
  PUBLIC = 0,

  /**
   * @generated from enum value: PRIVATE = 1;
   */
  PRIVATE = 1,

  /**
   * @generated from enum value: FRIENDS = 2;
   */
  FRIENDS = 2,
}

/**
 * Describes the enum evenplay.bay_session.v1.ListTournamentRequest.TournamentAccess.
 */
export const ListTournamentRequest_TournamentAccessSchema: GenEnum<ListTournamentRequest_TournamentAccess> = /*@__PURE__*/
  enumDesc(file_tournament_bay_session, 15, 0);

/**
 * @generated from enum evenplay.bay_session.v1.ListTournamentRequest.Sort
 */
export enum ListTournamentRequest_Sort {
  /**
   * @generated from enum value: DEFAULT = 0;
   */
  DEFAULT = 0,

  /**
   * @generated from enum value: ENTRY_BEGIN_DATE_SOONEST = 1;
   */
  ENTRY_BEGIN_DATE_SOONEST = 1,

  /**
   * @generated from enum value: ENTRY_BEGIN_DATE_LATEST = 2;
   */
  ENTRY_BEGIN_DATE_LATEST = 2,

  /**
   * @generated from enum value: ENTRY_END_DATE_SOONEST = 3;
   */
  ENTRY_END_DATE_SOONEST = 3,

  /**
   * @generated from enum value: ENTRY_END_DATE_LATEST = 4;
   */
  ENTRY_END_DATE_LATEST = 4,

  /**
   * @generated from enum value: FINISH_TIME = 5;
   */
  FINISH_TIME = 5,

  /**
   * @generated from enum value: START_TIME = 6;
   */
  START_TIME = 6,
}

/**
 * Describes the enum evenplay.bay_session.v1.ListTournamentRequest.Sort.
 */
export const ListTournamentRequest_SortSchema: GenEnum<ListTournamentRequest_Sort> = /*@__PURE__*/
  enumDesc(file_tournament_bay_session, 15, 1);

/**
 * @generated from message evenplay.bay_session.v1.ListTournamentReply
 */
export type ListTournamentReply = Message<"evenplay.bay_session.v1.ListTournamentReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: evenplay.bay_session.v1.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: repeated evenplay.bay_session.v1.Tournament tournaments = 3;
   */
  tournaments: Tournament[];
};

/**
 * Describes the message evenplay.bay_session.v1.ListTournamentReply.
 * Use `create(ListTournamentReplySchema)` to create a new message.
 */
export const ListTournamentReplySchema: GenMessage<ListTournamentReply> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 16);

/**
 * @generated from message evenplay.bay_session.v1.ListDefaultTournamentRequest
 */
export type ListDefaultTournamentRequest = Message<"evenplay.bay_session.v1.ListDefaultTournamentRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message evenplay.bay_session.v1.ListDefaultTournamentRequest.
 * Use `create(ListDefaultTournamentRequestSchema)` to create a new message.
 */
export const ListDefaultTournamentRequestSchema: GenMessage<ListDefaultTournamentRequest> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 17);

/**
 * @generated from message evenplay.bay_session.v1.ListDefaultTournamentReply
 */
export type ListDefaultTournamentReply = Message<"evenplay.bay_session.v1.ListDefaultTournamentReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: evenplay.bay_session.v1.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: repeated evenplay.bay_session.v1.Tournament tournaments = 3;
   */
  tournaments: Tournament[];
};

/**
 * Describes the message evenplay.bay_session.v1.ListDefaultTournamentReply.
 * Use `create(ListDefaultTournamentReplySchema)` to create a new message.
 */
export const ListDefaultTournamentReplySchema: GenMessage<ListDefaultTournamentReply> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 18);

/**
 * @generated from message evenplay.bay_session.v1.GetTournamentRequest
 */
export type GetTournamentRequest = Message<"evenplay.bay_session.v1.GetTournamentRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: int32 tournamentId = 2;
   */
  tournamentId: number;
};

/**
 * Describes the message evenplay.bay_session.v1.GetTournamentRequest.
 * Use `create(GetTournamentRequestSchema)` to create a new message.
 */
export const GetTournamentRequestSchema: GenMessage<GetTournamentRequest> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 19);

/**
 * @generated from message evenplay.bay_session.v1.GetTournamentReply
 */
export type GetTournamentReply = Message<"evenplay.bay_session.v1.GetTournamentReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: evenplay.bay_session.v1.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: evenplay.bay_session.v1.Tournament tournament = 3;
   */
  tournament?: Tournament;
};

/**
 * Describes the message evenplay.bay_session.v1.GetTournamentReply.
 * Use `create(GetTournamentReplySchema)` to create a new message.
 */
export const GetTournamentReplySchema: GenMessage<GetTournamentReply> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 20);

/**
 * @generated from message evenplay.bay_session.v1.JoinTournamentRequest
 */
export type JoinTournamentRequest = Message<"evenplay.bay_session.v1.JoinTournamentRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: int32 tournamentId = 2;
   */
  tournamentId: number;

  /**
   * @generated from field: int32 betEntreeFee = 3;
   */
  betEntreeFee: number;

  /**
   * @generated from field: repeated evenplay.bay_session.v1.TournamentSurveyAnswer surveyAnswers = 4;
   */
  surveyAnswers: TournamentSurveyAnswer[];

  /**
   * @generated from field: bool enter_with_ticket = 5;
   */
  enterWithTicket: boolean;

  /**
   * @generated from field: evenplay.bay_session.v1.Location location = 101;
   */
  location?: Location;

  /**
   * @generated from field: int32 venueId = 102;
   */
  venueId: number;
};

/**
 * Describes the message evenplay.bay_session.v1.JoinTournamentRequest.
 * Use `create(JoinTournamentRequestSchema)` to create a new message.
 */
export const JoinTournamentRequestSchema: GenMessage<JoinTournamentRequest> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 21);

/**
 * @generated from message evenplay.bay_session.v1.JoinTournamentReply
 */
export type JoinTournamentReply = Message<"evenplay.bay_session.v1.JoinTournamentReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: evenplay.bay_session.v1.Error error = 2;
   */
  error?: Error;
};

/**
 * Describes the message evenplay.bay_session.v1.JoinTournamentReply.
 * Use `create(JoinTournamentReplySchema)` to create a new message.
 */
export const JoinTournamentReplySchema: GenMessage<JoinTournamentReply> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 22);

/**
 * @generated from message evenplay.bay_session.v1.LeaveTournamentRequest
 */
export type LeaveTournamentRequest = Message<"evenplay.bay_session.v1.LeaveTournamentRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: int32 tournamentId = 2;
   */
  tournamentId: number;
};

/**
 * Describes the message evenplay.bay_session.v1.LeaveTournamentRequest.
 * Use `create(LeaveTournamentRequestSchema)` to create a new message.
 */
export const LeaveTournamentRequestSchema: GenMessage<LeaveTournamentRequest> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 23);

/**
 * @generated from message evenplay.bay_session.v1.LeaveTournamentReply
 */
export type LeaveTournamentReply = Message<"evenplay.bay_session.v1.LeaveTournamentReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: evenplay.bay_session.v1.Error error = 2;
   */
  error?: Error;
};

/**
 * Describes the message evenplay.bay_session.v1.LeaveTournamentReply.
 * Use `create(LeaveTournamentReplySchema)` to create a new message.
 */
export const LeaveTournamentReplySchema: GenMessage<LeaveTournamentReply> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 24);

/**
 * @generated from message evenplay.bay_session.v1.GetTournamentLeaderBoardRequest
 */
export type GetTournamentLeaderBoardRequest = Message<"evenplay.bay_session.v1.GetTournamentLeaderBoardRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: int64 playerId = 2;
   */
  playerId: bigint;

  /**
   * @generated from field: int32 tournamentId = 3;
   */
  tournamentId: number;

  /**
   * @generated from field: int32 topN = 4;
   */
  topN: number;
};

/**
 * Describes the message evenplay.bay_session.v1.GetTournamentLeaderBoardRequest.
 * Use `create(GetTournamentLeaderBoardRequestSchema)` to create a new message.
 */
export const GetTournamentLeaderBoardRequestSchema: GenMessage<GetTournamentLeaderBoardRequest> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 25);

/**
 * @generated from message evenplay.bay_session.v1.GetTournamentLeaderBoardReply
 */
export type GetTournamentLeaderBoardReply = Message<"evenplay.bay_session.v1.GetTournamentLeaderBoardReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: evenplay.bay_session.v1.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: bool hasActiveTournament = 3;
   */
  hasActiveTournament: boolean;

  /**
   * @generated from field: bool hasTournamentCompletedForUser = 4;
   */
  hasTournamentCompletedForUser: boolean;

  /**
   * @generated from field: repeated evenplay.bay_session.v1.TournamentLeaderBoardEntry entries = 5;
   */
  entries: TournamentLeaderBoardEntry[];
};

/**
 * Describes the message evenplay.bay_session.v1.GetTournamentLeaderBoardReply.
 * Use `create(GetTournamentLeaderBoardReplySchema)` to create a new message.
 */
export const GetTournamentLeaderBoardReplySchema: GenMessage<GetTournamentLeaderBoardReply> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 26);

/**
 * @generated from message evenplay.bay_session.v1.GetTournamentPlayersRequest
 */
export type GetTournamentPlayersRequest = Message<"evenplay.bay_session.v1.GetTournamentPlayersRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: int64 playerId = 2;
   */
  playerId: bigint;

  /**
   * @generated from field: int32 tournamentId = 3;
   */
  tournamentId: number;
};

/**
 * Describes the message evenplay.bay_session.v1.GetTournamentPlayersRequest.
 * Use `create(GetTournamentPlayersRequestSchema)` to create a new message.
 */
export const GetTournamentPlayersRequestSchema: GenMessage<GetTournamentPlayersRequest> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 27);

/**
 * @generated from message evenplay.bay_session.v1.GetTournamentPlayersReply
 */
export type GetTournamentPlayersReply = Message<"evenplay.bay_session.v1.GetTournamentPlayersReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: evenplay.bay_session.v1.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: repeated evenplay.bay_session.v1.GetTournamentPlayerEntry entries = 5;
   */
  entries: GetTournamentPlayerEntry[];
};

/**
 * Describes the message evenplay.bay_session.v1.GetTournamentPlayersReply.
 * Use `create(GetTournamentPlayersReplySchema)` to create a new message.
 */
export const GetTournamentPlayersReplySchema: GenMessage<GetTournamentPlayersReply> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 28);

/**
 * @generated from message evenplay.bay_session.v1.GetTournamentScheduleRequest
 */
export type GetTournamentScheduleRequest = Message<"evenplay.bay_session.v1.GetTournamentScheduleRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message evenplay.bay_session.v1.GetTournamentScheduleRequest.
 * Use `create(GetTournamentScheduleRequestSchema)` to create a new message.
 */
export const GetTournamentScheduleRequestSchema: GenMessage<GetTournamentScheduleRequest> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 29);

/**
 * @generated from message evenplay.bay_session.v1.GetTournamentScheduleReply
 */
export type GetTournamentScheduleReply = Message<"evenplay.bay_session.v1.GetTournamentScheduleReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: evenplay.bay_session.v1.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: repeated evenplay.bay_session.v1.LevelTournamentList levels = 3;
   */
  levels: LevelTournamentList[];
};

/**
 * Describes the message evenplay.bay_session.v1.GetTournamentScheduleReply.
 * Use `create(GetTournamentScheduleReplySchema)` to create a new message.
 */
export const GetTournamentScheduleReplySchema: GenMessage<GetTournamentScheduleReply> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 30);

/**
 * @generated from message evenplay.bay_session.v1.GetTournamentPrizeDistributionRequest
 */
export type GetTournamentPrizeDistributionRequest = Message<"evenplay.bay_session.v1.GetTournamentPrizeDistributionRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: int32 tournament_id = 2;
   */
  tournamentId: number;
};

/**
 * Describes the message evenplay.bay_session.v1.GetTournamentPrizeDistributionRequest.
 * Use `create(GetTournamentPrizeDistributionRequestSchema)` to create a new message.
 */
export const GetTournamentPrizeDistributionRequestSchema: GenMessage<GetTournamentPrizeDistributionRequest> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 31);

/**
 * @generated from message evenplay.bay_session.v1.GetTournamentPrizeDistributionReply
 */
export type GetTournamentPrizeDistributionReply = Message<"evenplay.bay_session.v1.GetTournamentPrizeDistributionReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: evenplay.bay_session.v1.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: evenplay.bay_session.v1.TournamentPrizeDistribution tournament_prize_distribution = 3;
   */
  tournamentPrizeDistribution?: TournamentPrizeDistribution;
};

/**
 * Describes the message evenplay.bay_session.v1.GetTournamentPrizeDistributionReply.
 * Use `create(GetTournamentPrizeDistributionReplySchema)` to create a new message.
 */
export const GetTournamentPrizeDistributionReplySchema: GenMessage<GetTournamentPrizeDistributionReply> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 32);

/**
 * @generated from message evenplay.bay_session.v1.CreatePrivateTournamentRequest
 */
export type CreatePrivateTournamentRequest = Message<"evenplay.bay_session.v1.CreatePrivateTournamentRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: int32 number_of_shots = 2;
   */
  numberOfShots: number;

  /**
   * @generated from field: int32 max_participants = 3;
   */
  maxParticipants: number;

  /**
   * @generated from field: int32 entree_fee = 4;
   */
  entreeFee: number;
};

/**
 * Describes the message evenplay.bay_session.v1.CreatePrivateTournamentRequest.
 * Use `create(CreatePrivateTournamentRequestSchema)` to create a new message.
 */
export const CreatePrivateTournamentRequestSchema: GenMessage<CreatePrivateTournamentRequest> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 33);

/**
 * @generated from message evenplay.bay_session.v1.CreatePrivateTournamentReply
 */
export type CreatePrivateTournamentReply = Message<"evenplay.bay_session.v1.CreatePrivateTournamentReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: evenplay.bay_session.v1.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: string new_tournament_code = 3;
   */
  newTournamentCode: string;

  /**
   * @generated from field: evenplay.bay_session.v1.Tournament tournament = 4;
   */
  tournament?: Tournament;
};

/**
 * Describes the message evenplay.bay_session.v1.CreatePrivateTournamentReply.
 * Use `create(CreatePrivateTournamentReplySchema)` to create a new message.
 */
export const CreatePrivateTournamentReplySchema: GenMessage<CreatePrivateTournamentReply> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 34);

/**
 * @generated from message evenplay.bay_session.v1.JoinPrivateTournamentRequest
 */
export type JoinPrivateTournamentRequest = Message<"evenplay.bay_session.v1.JoinPrivateTournamentRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: int32 betEntreeFee = 3;
   */
  betEntreeFee: number;

  /**
   * @generated from field: repeated evenplay.bay_session.v1.TournamentSurveyAnswer surveyAnswers = 4;
   */
  surveyAnswers: TournamentSurveyAnswer[];

  /**
   * @generated from field: evenplay.bay_session.v1.Location location = 101;
   */
  location?: Location;

  /**
   * @generated from field: int32 venueId = 102;
   */
  venueId: number;
};

/**
 * Describes the message evenplay.bay_session.v1.JoinPrivateTournamentRequest.
 * Use `create(JoinPrivateTournamentRequestSchema)` to create a new message.
 */
export const JoinPrivateTournamentRequestSchema: GenMessage<JoinPrivateTournamentRequest> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 35);

/**
 * @generated from message evenplay.bay_session.v1.JoinPrivateTournamentReply
 */
export type JoinPrivateTournamentReply = Message<"evenplay.bay_session.v1.JoinPrivateTournamentReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: evenplay.bay_session.v1.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: evenplay.bay_session.v1.Tournament tournament = 3;
   */
  tournament?: Tournament;
};

/**
 * Describes the message evenplay.bay_session.v1.JoinPrivateTournamentReply.
 * Use `create(JoinPrivateTournamentReplySchema)` to create a new message.
 */
export const JoinPrivateTournamentReplySchema: GenMessage<JoinPrivateTournamentReply> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 36);

/**
 * @generated from message evenplay.bay_session.v1.VerifyPrivateTournamentCodeRequest
 */
export type VerifyPrivateTournamentCodeRequest = Message<"evenplay.bay_session.v1.VerifyPrivateTournamentCodeRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: evenplay.bay_session.v1.Location location = 101;
   */
  location?: Location;

  /**
   * @generated from field: int32 venueId = 102;
   */
  venueId: number;
};

/**
 * Describes the message evenplay.bay_session.v1.VerifyPrivateTournamentCodeRequest.
 * Use `create(VerifyPrivateTournamentCodeRequestSchema)` to create a new message.
 */
export const VerifyPrivateTournamentCodeRequestSchema: GenMessage<VerifyPrivateTournamentCodeRequest> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 37);

/**
 * @generated from message evenplay.bay_session.v1.VerifyPrivateTournamentCodeReply
 */
export type VerifyPrivateTournamentCodeReply = Message<"evenplay.bay_session.v1.VerifyPrivateTournamentCodeReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: evenplay.bay_session.v1.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: evenplay.bay_session.v1.Tournament tournament = 3;
   */
  tournament?: Tournament;
};

/**
 * Describes the message evenplay.bay_session.v1.VerifyPrivateTournamentCodeReply.
 * Use `create(VerifyPrivateTournamentCodeReplySchema)` to create a new message.
 */
export const VerifyPrivateTournamentCodeReplySchema: GenMessage<VerifyPrivateTournamentCodeReply> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 38);

/**
 * @generated from message evenplay.bay_session.v1.GetTournamentMetadataRequest
 */
export type GetTournamentMetadataRequest = Message<"evenplay.bay_session.v1.GetTournamentMetadataRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: int32 tournament_id = 2;
   */
  tournamentId: number;
};

/**
 * Describes the message evenplay.bay_session.v1.GetTournamentMetadataRequest.
 * Use `create(GetTournamentMetadataRequestSchema)` to create a new message.
 */
export const GetTournamentMetadataRequestSchema: GenMessage<GetTournamentMetadataRequest> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 39);

/**
 * @generated from message evenplay.bay_session.v1.GetTournamentMetadataReply
 */
export type GetTournamentMetadataReply = Message<"evenplay.bay_session.v1.GetTournamentMetadataReply"> & {
  /**
   * unset when not found
   *
   * @generated from field: evenplay.bay_session.v1.TournamentMetadata metadata = 1;
   */
  metadata?: TournamentMetadata;
};

/**
 * Describes the message evenplay.bay_session.v1.GetTournamentMetadataReply.
 * Use `create(GetTournamentMetadataReplySchema)` to create a new message.
 */
export const GetTournamentMetadataReplySchema: GenMessage<GetTournamentMetadataReply> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 40);

/**
 * @generated from message evenplay.bay_session.v1.GetTournamentForSimulatorRequest
 */
export type GetTournamentForSimulatorRequest = Message<"evenplay.bay_session.v1.GetTournamentForSimulatorRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: int64 station_id = 2;
   */
  stationId: bigint;

  /**
   * @generated from field: int64 tournament_id = 3;
   */
  tournamentId: bigint;
};

/**
 * Describes the message evenplay.bay_session.v1.GetTournamentForSimulatorRequest.
 * Use `create(GetTournamentForSimulatorRequestSchema)` to create a new message.
 */
export const GetTournamentForSimulatorRequestSchema: GenMessage<GetTournamentForSimulatorRequest> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 41);

/**
 * @generated from message evenplay.bay_session.v1.GetTournamentForSimulatorReply
 */
export type GetTournamentForSimulatorReply = Message<"evenplay.bay_session.v1.GetTournamentForSimulatorReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: evenplay.bay_session.v1.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: evenplay.bay_session.v1.Tournament tournament = 3;
   */
  tournament?: Tournament;
};

/**
 * Describes the message evenplay.bay_session.v1.GetTournamentForSimulatorReply.
 * Use `create(GetTournamentForSimulatorReplySchema)` to create a new message.
 */
export const GetTournamentForSimulatorReplySchema: GenMessage<GetTournamentForSimulatorReply> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 42);

/**
 * @generated from message evenplay.bay_session.v1.ListActiveTournamentsRequest
 */
export type ListActiveTournamentsRequest = Message<"evenplay.bay_session.v1.ListActiveTournamentsRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message evenplay.bay_session.v1.ListActiveTournamentsRequest.
 * Use `create(ListActiveTournamentsRequestSchema)` to create a new message.
 */
export const ListActiveTournamentsRequestSchema: GenMessage<ListActiveTournamentsRequest> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 43);

/**
 * @generated from message evenplay.bay_session.v1.ListActiveTournamentsReply
 */
export type ListActiveTournamentsReply = Message<"evenplay.bay_session.v1.ListActiveTournamentsReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: evenplay.bay_session.v1.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: repeated evenplay.bay_session.v1.Tournament tournaments = 3;
   */
  tournaments: Tournament[];
};

/**
 * Describes the message evenplay.bay_session.v1.ListActiveTournamentsReply.
 * Use `create(ListActiveTournamentsReplySchema)` to create a new message.
 */
export const ListActiveTournamentsReplySchema: GenMessage<ListActiveTournamentsReply> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 44);

/**
 * @generated from message evenplay.bay_session.v1.PinTournamentRequest
 */
export type PinTournamentRequest = Message<"evenplay.bay_session.v1.PinTournamentRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: int64 station_id = 3;
   */
  stationId: bigint;

  /**
   * @generated from field: int64 tournament_id = 4;
   */
  tournamentId: bigint;

  /**
   * @generated from field: int64 player_id = 5;
   */
  playerId: bigint;
};

/**
 * Describes the message evenplay.bay_session.v1.PinTournamentRequest.
 * Use `create(PinTournamentRequestSchema)` to create a new message.
 */
export const PinTournamentRequestSchema: GenMessage<PinTournamentRequest> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 45);

/**
 * @generated from message evenplay.bay_session.v1.PinTournamentReply
 */
export type PinTournamentReply = Message<"evenplay.bay_session.v1.PinTournamentReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: evenplay.bay_session.v1.Error error = 2;
   */
  error?: Error;
};

/**
 * Describes the message evenplay.bay_session.v1.PinTournamentReply.
 * Use `create(PinTournamentReplySchema)` to create a new message.
 */
export const PinTournamentReplySchema: GenMessage<PinTournamentReply> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 46);

/**
 * @generated from message evenplay.bay_session.v1.UnPinTournamentRequest
 */
export type UnPinTournamentRequest = Message<"evenplay.bay_session.v1.UnPinTournamentRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: int64 station_id = 3;
   */
  stationId: bigint;

  /**
   * @generated from field: int64 tournament_id = 4;
   */
  tournamentId: bigint;
};

/**
 * Describes the message evenplay.bay_session.v1.UnPinTournamentRequest.
 * Use `create(UnPinTournamentRequestSchema)` to create a new message.
 */
export const UnPinTournamentRequestSchema: GenMessage<UnPinTournamentRequest> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 47);

/**
 * @generated from message evenplay.bay_session.v1.UnPinTournamentReply
 */
export type UnPinTournamentReply = Message<"evenplay.bay_session.v1.UnPinTournamentReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: evenplay.bay_session.v1.Error error = 2;
   */
  error?: Error;
};

/**
 * Describes the message evenplay.bay_session.v1.UnPinTournamentReply.
 * Use `create(UnPinTournamentReplySchema)` to create a new message.
 */
export const UnPinTournamentReplySchema: GenMessage<UnPinTournamentReply> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 48);

/**
 * @generated from message evenplay.bay_session.v1.StreamTournamentUpdatesRequest
 */
export type StreamTournamentUpdatesRequest = Message<"evenplay.bay_session.v1.StreamTournamentUpdatesRequest"> & {
  /**
   * @generated from field: int32 tournamentId = 2;
   */
  tournamentId: number;
};

/**
 * Describes the message evenplay.bay_session.v1.StreamTournamentUpdatesRequest.
 * Use `create(StreamTournamentUpdatesRequestSchema)` to create a new message.
 */
export const StreamTournamentUpdatesRequestSchema: GenMessage<StreamTournamentUpdatesRequest> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 49);

/**
 * @generated from message evenplay.bay_session.v1.StreamTournamentUpdatesReply
 */
export type StreamTournamentUpdatesReply = Message<"evenplay.bay_session.v1.StreamTournamentUpdatesReply"> & {
  /**
   * @generated from field: evenplay.bay_session.v1.StreamTournamentUpdatesTournamentInfo tournament = 3;
   */
  tournament?: StreamTournamentUpdatesTournamentInfo;
};

/**
 * Describes the message evenplay.bay_session.v1.StreamTournamentUpdatesReply.
 * Use `create(StreamTournamentUpdatesReplySchema)` to create a new message.
 */
export const StreamTournamentUpdatesReplySchema: GenMessage<StreamTournamentUpdatesReply> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 50);

/**
 * @generated from message evenplay.bay_session.v1.StreamTournamentUpdatesTournamentInfo
 */
export type StreamTournamentUpdatesTournamentInfo = Message<"evenplay.bay_session.v1.StreamTournamentUpdatesTournamentInfo"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: bool isPrivate = 3;
   */
  isPrivate: boolean;

  /**
   * @generated from field: string sponsorLogo = 4;
   */
  sponsorLogo: string;

  /**
   * @generated from field: int64 expirationDate = 8;
   */
  expirationDate: bigint;

  /**
   * @generated from field: repeated int32 prizePool = 9;
   */
  prizePool: number[];

  /**
   * @generated from field: repeated evenplay.bay_session.v1.StreamTournamentUpdatesLeaderBoardEntry leaderboardEntries = 10;
   */
  leaderboardEntries: StreamTournamentUpdatesLeaderBoardEntry[];

  /**
   * @generated from field: repeated evenplay.bay_session.v1.StreamTournamentUpdatesTournamentPlayerEntry players = 11;
   */
  players: StreamTournamentUpdatesTournamentPlayerEntry[];
};

/**
 * Describes the message evenplay.bay_session.v1.StreamTournamentUpdatesTournamentInfo.
 * Use `create(StreamTournamentUpdatesTournamentInfoSchema)` to create a new message.
 */
export const StreamTournamentUpdatesTournamentInfoSchema: GenMessage<StreamTournamentUpdatesTournamentInfo> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 51);

/**
 * @generated from message evenplay.bay_session.v1.StreamTournamentUpdatesLeaderBoardEntry
 */
export type StreamTournamentUpdatesLeaderBoardEntry = Message<"evenplay.bay_session.v1.StreamTournamentUpdatesLeaderBoardEntry"> & {
  /**
   * @generated from field: int32 rank = 1;
   */
  rank: number;

  /**
   * @generated from field: string playerUsername = 2;
   */
  playerUsername: string;

  /**
   * @generated from field: string playerFirstName = 3;
   */
  playerFirstName: string;

  /**
   * @generated from field: string playerLastName = 4;
   */
  playerLastName: string;

  /**
   * @generated from field: int32 score = 5;
   */
  score: number;

  /**
   * @generated from field: int32 shotsCompleted = 6;
   */
  shotsCompleted: number;

  /**
   * @generated from field: bool isCurrentUser = 7;
   */
  isCurrentUser: boolean;

  /**
   * @generated from field: string playerUsernameId = 8;
   */
  playerUsernameId: string;
};

/**
 * Describes the message evenplay.bay_session.v1.StreamTournamentUpdatesLeaderBoardEntry.
 * Use `create(StreamTournamentUpdatesLeaderBoardEntrySchema)` to create a new message.
 */
export const StreamTournamentUpdatesLeaderBoardEntrySchema: GenMessage<StreamTournamentUpdatesLeaderBoardEntry> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 52);

/**
 * @generated from message evenplay.bay_session.v1.StreamTournamentUpdatesTournamentPlayerEntry
 */
export type StreamTournamentUpdatesTournamentPlayerEntry = Message<"evenplay.bay_session.v1.StreamTournamentUpdatesTournamentPlayerEntry"> & {
  /**
   * @generated from field: string playerUsername = 2;
   */
  playerUsername: string;

  /**
   * @generated from field: string playerFirstName = 3;
   */
  playerFirstName: string;

  /**
   * @generated from field: string playerLastName = 4;
   */
  playerLastName: string;
};

/**
 * Describes the message evenplay.bay_session.v1.StreamTournamentUpdatesTournamentPlayerEntry.
 * Use `create(StreamTournamentUpdatesTournamentPlayerEntrySchema)` to create a new message.
 */
export const StreamTournamentUpdatesTournamentPlayerEntrySchema: GenMessage<StreamTournamentUpdatesTournamentPlayerEntry> = /*@__PURE__*/
  messageDesc(file_tournament_bay_session, 53);

/**
 * Represents the possible states of a tournament.
 *
 * @generated from enum evenplay.bay_session.v1.TournamentState
 */
export enum TournamentState {
  /**
   * Tournament is created but not yet started
   *
   * @generated from enum value: PENDING = 0;
   */
  PENDING = 0,

  /**
   * Tournament is published and visible to users
   *
   * @generated from enum value: PUBLISHED = 1;
   */
  PUBLISHED = 1,

  /**
   * Tournament is currently in progress
   *
   * @generated from enum value: PLAYING = 2;
   */
  PLAYING = 2,

  /**
   * Tournament has completed
   *
   * @generated from enum value: FINISHED = 3;
   */
  FINISHED = 3,

  /**
   * Tournament was cancelled before completion
   *
   * @generated from enum value: CANCELLED = 4;
   */
  CANCELLED = 4,

  /**
   * Tournament was voided (results invalidated)
   *
   * @generated from enum value: VOIDED = 5;
   */
  VOIDED = 5,
}

/**
 * Describes the enum evenplay.bay_session.v1.TournamentState.
 */
export const TournamentStateSchema: GenEnum<TournamentState> = /*@__PURE__*/
  enumDesc(file_tournament_bay_session, 0);

/**
 * @generated from enum evenplay.bay_session.v1.TournamentJoinOptions
 */
export enum TournamentJoinOptions {
  /**
   * Player can join only with money
   *
   * @generated from enum value: ONLY_MONEY = 0;
   */
  ONLY_MONEY = 0,

  /**
   * Player can join only with ticket
   *
   * @generated from enum value: ONLY_TICKET = 1;
   */
  ONLY_TICKET = 1,

  /**
   * Needs a ticket AND entry fee
   *
   * @generated from enum value: MONEY_AND_TICKET = 2;
   */
  MONEY_AND_TICKET = 2,

  /**
   * Needs either a ticket OR entry fee
   *
   * @generated from enum value: MONEY_OR_TICKET = 3;
   */
  MONEY_OR_TICKET = 3,
}

/**
 * Describes the enum evenplay.bay_session.v1.TournamentJoinOptions.
 */
export const TournamentJoinOptionsSchema: GenEnum<TournamentJoinOptions> = /*@__PURE__*/
  enumDesc(file_tournament_bay_session, 1);

/**
 * @generated from enum evenplay.bay_session.v1.TournamentSurveyQuestionType
 */
export enum TournamentSurveyQuestionType {
  /**
   * @generated from enum value: TEXT_ENTRY = 0;
   */
  TEXT_ENTRY = 0,

  /**
   * @generated from enum value: DROPDOWN = 1;
   */
  DROPDOWN = 1,

  /**
   * @generated from enum value: MULTI_CHOICE = 2;
   */
  MULTI_CHOICE = 2,
}

/**
 * Describes the enum evenplay.bay_session.v1.TournamentSurveyQuestionType.
 */
export const TournamentSurveyQuestionTypeSchema: GenEnum<TournamentSurveyQuestionType> = /*@__PURE__*/
  enumDesc(file_tournament_bay_session, 2);

